/**
 * The two levels at which a scanned element carries documents. An operator needs both:
 *   - INSTANCE  — what belongs to this very lot / part / tool (its certificate, its measurements).
 *   - REFERENCE — what belongs to the article it is an instance of. This is where the DRAWINGS live,
 *                 and it is what the "documentation" entry point goes to by default.
 *
 * The `resourceType` each level maps to is NOT decided here: Sun sends it inside the scan answer,
 * together with the id and the document count, so the front never resolves identity out of a QR
 * payload (uppercased and lossy by design) and a resource type renamed in the backend needs no
 * front release. Which levels exist is the backend's call too — a fabrication order or an order has
 * no reference level of its own, and neither does a raw-material lot without a reference.
 */

export const DOCUMENT_SCOPES = { INSTANCE: 'INSTANCE', REFERENCE: 'REFERENCE' }
